import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
// axios
import axios from '@/axios/request';
Vue.prototype.$axios = axios;

// waves
import Waves from 'jycomponents/waves';
Vue.use(Waves);
// filter
import 'jyutils/filter';

Vue.prototype.$bus = new Vue();

// import { baseUrl, baseWs, baseUrl_dev, baseWs_dev } from '../../public/static/js/constant';
export function urlConfig(callback) {
  axios.get((process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ASSETPATH_PRD : process.env.VUE_APP_ASSETPATH_DEV) +'static/js/config.json').then((res) => {
    Vue.prototype.apptitle = res.data.apptitle;
    Vue.prototype.baseUrl_dev = res.data.baseUrl_dev;
    callback();
  });

  // let baseUrl = '', baseWs = '', baseUrl_dev = '', baseWs_dev = '';
  // axios.defaults.baseURL = baseUrl;
  // axios.get((process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ASSETPATH_PRD : process.env.VUE_APP_ASSETPATH_DEV) +'static/js/config.json').then((res)=>{
  //   // console.log(res.data)
  //   Vue.prototype.apptitle = res.data.apptitle;
  //   baseUrl = res.data.baseUrl;
  //   baseWs = res.data.baseWs;
  //   baseUrl_dev = res.data.baseUrl_dev;
  //   baseWs_dev = res.data.baseWs_dev;
  //   // for VueResource
  //   if (process.env.NODE_ENV === 'production') {
  //     // console.log('生产')
  //     /* for axios */
  //     Vue.prototype.projectPath = baseUrl +'static/js/';
  //     axios.defaults.domain = baseUrl; //'http://yuanfang.cdjinyang.com';
  //     axios.defaults.baseURL = baseUrl; //'http://yuanfang.cdjinyang.com';
  //     axios.defaults.wsroot = baseWs; //'ws://yuanfang.cdjinyang.com/websocket';
  //     axios.defaults.wx_root = baseUrl + '/'; //'http://yuanfang.cdjinyang.com/';
  //   } else {
  //     console.log('开发')
  //     Vue.prototype.projectPath = 'http://localhost:8080/static/js/';
  //     axios.defaults.domain = baseUrl_dev; //'http://test.cdjinyang.com';
  //     axios.defaults.baseURL = baseUrl_dev; //'http://test.cdjinyang.com';
  //     axios.defaults.wsroot = baseWs_dev; //'ws://test.cdjinyang.com/websocket';
  //     axios.defaults.wx_root = baseUrl_dev + '/'; //'http://test.cdjinyang.com/';
  //   }
  //   callback();
  // });
}

// 高德地图 key
export const MapKey = 'be2f0b31ae60cc7533c6330db464caef';
// 地图限定城市
export const MapCityName = '全国';
// 初始坐标
export const MapLnglat = [104.164311, 30.60970];

// other
String.prototype.startWith = function(str) {
  let reg = new RegExp("^" + str);
  return reg.test(this);
}

String.prototype.endWith = function(str) {
  let reg = new RegExp(str + "$");
  return reg.test(this);
}

String.prototype.toDate = function() {
  if (!this) return null;
  return new Date(this.replace(/-/g, '/'));
}

String.prototype.isUrl = function() {
  if (!this) return false;
  let str = this.toLowerCase().trim();
  return str.startWith('http') || str.startWith('//');
}

String.prototype.addDay = function(day = 0, fmt = 'yyyy-MM-dd') {
  if (!this) return null;
  var date = new Date(this.replace(/-/g, '/'));
  var time = 0;
  if (date) {
    time = date.getTime() + (day * 86400000);
  }
  return time ? new Date(time).Format(fmt) : this;
}

Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };

  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));

  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

  return fmt;
}
